import axios from 'axios'

const apiClient = axios.create({
  baseURL: 'https://dashamajig.chibitronics.com/api',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
})

function authHeaders() {
  const token = localStorage.getItem('token')
  if (!token) return {}
  return { Authorization: `Bearer ${token}`, 'X-Auth-Token': token }
}

export default {
  status() {
    return apiClient.get('/gmail/status', { headers: authHeaders() })
  },

  sendEmail(payload) {
    return apiClient.post('/gmail/send', payload, {
      headers: authHeaders()
    })
  }
}
